import { TableSection } from '@/components/Section/TableSection'
import { flexGroupListContext } from 'BrokerTsLib/src/context'
import { FlexGroupType } from 'BrokerTsLib/src/enums'
import { useOrganizationFlexGroups } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { FlexGroupList } from '../flex-group'

export const OrganizationUnitFlexGroups = ({
  organizationUnitId,
}: {
  organizationUnitId: number
}) => {

  const { flexGroups, isLoading, refetch } = useOrganizationFlexGroups(organizationUnitId, FlexGroupType.Default)

  return (
    <TableSection
      cardHeaderProps={{ py: 2 }}
      sectionTitle="Flexibilní skupiny"
      wide
    >
      <flexGroupListContext.Provider value={{
        loading: isLoading,
        totalCount: flexGroups?.length ?? 0,
        currentPage: 1,
        pageSize: 10,
        filter: { showInvalid: false, pageIndex: 1 },
        setCurrentPage: () => { },
        setPageSize: () => { },
        updateFilter: () => { },
        reload: () => refetch(),
      }}>
        <FlexGroupList flexGroups={flexGroups ?? []} />
      </flexGroupListContext.Provider>
    </TableSection>)
}
